import { LanguageRegionCode } from '@alltrails/shared/utils/languageSupport';

export default function useLanguageRegionCode(): LanguageRegionCode {
  return global.__AT_STORE__.languageRegionCode;
}
